export const projects = [
    {
        title: "Next.js – Node.js – TypeScript – Tailwind – Kanban Board App.",
        desc: "This is a Kanban Task Management System. You can create, delete, update and read your tasks. Also you can change the status of the tasks. Start instantly without login!",
        tags: [
            {
                name: "Next.Js",
                color: "#fff",
            },
            {
                name: "Tailwind",
                color: "#32612D",
            }
        ],
        img: "https://logowik.com/content/uploads/images/nextjs2106.logowik.com.webp",
        link: "https://kanbantask-frontend.vercel.app/",
    },
    {
        title: "MERN-Stack E-commerce Website",
        desc: "An e-commerce website with backend (Rest API) and frontend. All documents in the file and you just need to \"npm start\"." +
            "You can buy or sell anything in the website. This is not a real website, because of that just don't forget to use " +
            "\"Strapi\" demo cards to pay the payments.",
        tags: [
            {
                name: "Express.Js",
                color: "red",
            },
            {
                name: "MongoDb",
                color: "green",
            },
            {
                name: "React",
                color: "#4f42b5",
            },
            {
                name: "Node.Js",
                color: "#68a063",
            },
        ],
        img: "https://miro.medium.com/v2/resize:fit:678/0*kxPYwfJmkXZ3iCWy.png",
        gitHubLink: "https://github.com/tfihsdeR/FullStackEcommerceWebsiteUsingMERN",
    },
    {
        title: "Event REST API with .Net",
        desc: "An event API that you can check all informations for all events in all time. Also you can add an event by requests.",
        tags: [
            {
                name: ".Net",
                color: "#6D287E",
            },
            {
                name: "SQL Server",
                color: "blue",
            }
        ],
        img: "https://www.pngmart.com/files/21/Net-PNG-Image.png",
        gitHubLink: "https://github.com/tfihsdeR/EventApi.git",
    },
    {
        title: "BIST-30-Forecasting-with-Time-Series",
        desc: "A trade market forcasting application that forcasts only 3 days later (Data should be daily!). You can change the forcasting time delay but this is the most "
            + "better delay time. Also you can change the data and forcast anything for daily datas.",
        tags: [
            {
                name: "Python",
                color: "#4B8BBE",
            }
        ],
        img: "https://i0.wp.com/mertcangokgoz.com/wp-content/uploads/2018/11/python.png?fit=1920%2C1080&ssl=1",
        gitHubLink: "https://github.com/tfihsdeR/BIST-30-Forecasting-with-Time-Series",
    },

];
